import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import ShowAll from "./components/ShowAll/ShowAll";
import CallFilterBar, {
  CallFilters,
  parseCallFiltersFromSearch,
} from "./CallFilterBar";

const CallLogsPage = () => {
  const location = useLocation();
  const [filters, setFilters] = useState<CallFilters>(() =>
    parseCallFiltersFromSearch(location.search)
  );

  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white">
      <div className="shrink-0 border-b border-[#EEF0F5] px-4 py-4 sm:px-5 lg:px-6">
        <h1 className="text-2xl font-bold tracking-tight text-[#111827]">
          Call Logs
        </h1>
        <p className="mt-1 text-sm text-[#6B7280]">
          Totals, status filters, and recordings for every IVR call
        </p>
        <div className="mt-4">
          <CallFilterBar value={filters} onChange={setFilters} />
        </div>
      </div>
      <div className="min-h-0 flex-1 overflow-auto p-4 sm:p-5 lg:p-6">
        <ShowAll filters={filters} />
      </div>
    </div>
  );
};

export default CallLogsPage;
